import { TopLogoViewFg } from "@quest/murka-games-behavior-leopard/dist/Game/TopLogo/TopLogoViewFg";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist/";
import { dispatcher, ingenuity } from "@quest/base-core";
import { gameConstants } from "../Constants/gameConstants";
export class TopLogoViewGameFG extends TopLogoViewFg {

    //Function overided to remove button shape and update pivot value
    public topSpace(): void {
        if (this.currentStateView) {
            const logoHeightBg = this.getShapeById("logoHeightBg");
            if (logoHeightBg) {
                const wrapperTopBarHeight = document.getElementById("topbar") ? (document.getElementById("topbar").offsetHeight ? document.getElementById("topbar").offsetHeight : SlotConstantsBehavior.WrapperBottomBarHeightMobilePortrait) : 0;
                const reelBgHeight = SlotConstantsBehavior.REEL_MAXSCALE_HEIGHT;
                const gameLogoWidth: number = gameConstants.GAME_LOGO_WIDTH;
                const gameLogoHeight: number = gameConstants.GAME_LOGO_HEIGHT;
                /* we use window.innerHeight/2 + SlotConstantsBehavior.ADD_IN_Y as it's the basegame view's position
                 * did not used this.currentView.y to handle in pola
                 * to remove glitch during pola
                 */
                const freeViewScale: number = ingenuity.deviceEnv.getPortraitMaxReelScale();
                const topSpace = ((window.innerHeight / 2 + SlotConstantsBehavior.ADD_IN_Y) - (reelBgHeight / 2) * freeViewScale) - wrapperTopBarHeight ;
                const availableScaling = Math.min(topSpace / logoHeightBg.height, window.innerWidth / logoHeightBg.width);
                dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_LANDSCAPE_LOGO);
                this.showView();
                this.scale.set(availableScaling);
                this.pivot.set(gameLogoWidth / 2, gameLogoHeight / 2);
                this.x = window.innerWidth / 2;
                this.y = wrapperTopBarHeight + topSpace / 2;
            }
            const stateViewIndex = ingenuity.currentGame.stage.getChildIndex(this.currentStateView);
            ingenuity.currentGame.stage.addChildAt(this, stateViewIndex - 1);
        }
    }
}